const SectionHeader = ({ title }) => (
    <div className="mb-6">
      <h2 className="text-2xl font-semibold">{title}</h2>
      <div className="w-14 h-1 bg-white/20 mt-2 rounded-full" />
    </div>
  );
  
  export default SectionHeader;